export function isSelect(elm: Element): elm is HTMLSelectElement {
    return elm.nodeName == 'SELECT';
}

export function isInput(elm: Element): elm is HTMLInputElement {
    return elm.nodeName == 'INPUT' || elm.nodeName == 'TEXTAREA';
}
